import React from 'react'

const DataTable = ({ heading, dataTable }) => (
  <div className="bg-white shadow-box p-7 rounded-[5px]">
    <h3 className="mb-8 font-bold u-p">{heading}</h3>
    <div className="space-y-5">
      {dataTable.map(row =>
        row.divider || !row.icon[0] ? (
          <div key={row.itemTitle} className="border-b border-grey-4" />
        ) : (
          <div
            key={`${row.itemTitle}-${row.icon[0].url}`}
            className="flex items-center"
          >
            <img
              src={row.icon[0].url}
              alt=""
              className={`w-5.5 h-auto mr-1.5 relative ${
                !row.itemTitle && 'top-2'
              }`}
            />
            <div>
              <div className="text-red-as text-[11px] font-bold">
                {row.itemTitle}
              </div>
              <div className="u-p-small">{row.text}</div>
            </div>
          </div>
        ),
      )}
    </div>
  </div>
)

export default DataTable
